import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header__search-overlay-inner" }
const _hoisted_3 = { class: "header__search-overlay-input-wrapper" }
const _hoisted_4 = {
  key: 0,
  class: "header__search-dropdown"
}
const _hoisted_5 = {
  key: 0,
  class: "header__search-dropdown-loading"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "header__search-dropdown-info" }
const _hoisted_9 = { class: "header__search-dropdown-title" }
const _hoisted_10 = { class: "header__search-dropdown-price" }
const _hoisted_11 = {
  key: 2,
  class: "header__search-dropdown-empty"
}
const _hoisted_12 = { class: "header__inner" }
const _hoisted_13 = { class: "header__nav" }
const _hoisted_14 = { class: "header__nav-links" }
const _hoisted_15 = { class: "header__actions" }
const _hoisted_16 = { class: "header__search" }
const _hoisted_17 = {
  key: 0,
  class: "header__search-dropdown"
}
const _hoisted_18 = {
  key: 0,
  class: "header__search-dropdown-loading"
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["src", "alt"]
const _hoisted_21 = { class: "header__search-dropdown-info" }
const _hoisted_22 = { class: "header__search-dropdown-title" }
const _hoisted_23 = { class: "header__search-dropdown-price" }
const _hoisted_24 = {
  key: 2,
  class: "header__search-dropdown-empty"
}

import { useSearch } from "@/composables/useSearch";
import CartComponent from "@/modules/cart/components/CartComponent.vue";
import { nextTick, ref, watch } from "vue";
import { RouterLink, useRoute } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderComponent',
  setup(__props) {

/**
 * Header component
 *
 * Renders the main site navigation, desktop and mobile search inputs,
 * mobile menu, and cart access.
 *
 * Responsibilities:
 *  - displays navigation links for main routes
 *  - integrates the product search composable
 *  - opens and closes the mobile menu
 *  - opens the mobile search overlay and focuses the input
 *  - resets menu/search UI state when the route changes
 *
 * Local state:
 *  - isMenuOpen: controls the mobile navigation drawer
 *  - isSearchOpen: controls the mobile search overlay
 *  - mobileSearch: input ref used to focus the mobile search field
 */
const route = useRoute();

const {
  showNoResults,
  handleSearchInput,
  handleSearch,
  handleSelectResult,
  searchLoading,
  searchQuery,
  searchResults,
} = useSearch();

const navLinks = [
  {
    id: 1,
    to: "/",
    name: "Home",
    exact: true,
  },
  {
    id: 2,
    to: "/contact",
    name: "Contact",
  },
  {
    id: 3,
    to: "/products",
    name: "Products",
  },
  {
    id: 4,
    to: "/about",
    name: "About",
  },
];

const isMenuOpen = ref(false);
const isSearchOpen = ref(false);

watch(
  () => route.fullPath,
  () => {
    isMenuOpen.value = false;
    isSearchOpen.value = false;
  }
);

function toggleMenu() {
  isMenuOpen.value = !isMenuOpen.value;
}

const mobileSearch = ref<HTMLInputElement | null>(null);
function openSearch() {
  isSearchOpen.value = true;
  nextTick(() => {
    mobileSearch.value?.focus();
  });
}

function closeSearch() {
  isSearchOpen.value = false;
  searchQuery.value = "";
}

return (_ctx: any,_cache: any) => {
  const _component_base_loader = _resolveComponent("base-loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isSearchOpen.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "header__search-overlay",
          onClick: _withModifiers(closeSearch, ["self"])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _withDirectives(_createElementVNode("input", {
                ref_key: "mobileSearch",
                ref: mobileSearch,
                class: "header__search-overlay-input",
                type: "text",
                placeholder: "What are you looking for?",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(searchQuery) ? (searchQuery).value = $event : null)),
                onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(handleSearchInput) && _unref(handleSearchInput)(...args))),
                onKeyup: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_unref(handleSearch) && _unref(handleSearch)(...args)), ["enter"]))
              }, null, 544), [
                [_vModelText, _unref(searchQuery)]
              ]),
              _createElementVNode("div", {
                class: "header__search-overlay-icon",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(handleSearch) && _unref(handleSearch)(...args)))
              }, [...(_cache[7] || (_cache[7] = [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor",
                  "stroke-width": "2"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M21 21l-4.35-4.35m0 0A7.5 7.5 0 1110.5 3a7.5 7.5 0 016.15 13.65z"
                  })
                ], -1)
              ]))])
            ]),
            (_unref(searchResults).length > 0 || _unref(searchLoading) || _unref(showNoResults))
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_unref(searchLoading))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createVNode(_component_base_loader, { size: "24px" })
                      ]))
                    : (_unref(searchResults).length > 0)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(searchResults), (result) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: result.id,
                            class: "header__search-dropdown-item",
                            onClick: ($event: any) => (_unref(handleSelectResult)(result))
                          }, [
                            _createElementVNode("img", {
                              src: result.thumbnail,
                              alt: result.title
                            }, null, 8, _hoisted_7),
                            _createElementVNode("div", _hoisted_8, [
                              _createElementVNode("p", _hoisted_9, _toDisplayString(result.title), 1),
                              _createElementVNode("p", _hoisted_10, "$" + _toDisplayString(result.price), 1)
                            ])
                          ], 8, _hoisted_6))
                        }), 128))
                      : (_openBlock(), _createElementBlock("div", _hoisted_11, " No products found "))
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("header", _hoisted_12, [
      _createElementVNode("div", {
        class: _normalizeClass([
          'header__mobile-menu',
          { 'header__mobile-menu--open': isMenuOpen.value },
        ])
      }, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navLinks, (link) => {
          return _createVNode(_unref(RouterLink), {
            key: link.id,
            class: "header__mobile-link",
            to: link.to,
            exact: link.exact
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(link.name), 1)
            ]),
            _: 2
          }, 1032, ["to", "exact"])
        }), 64))
      ], 2),
      _createElementVNode("nav", _hoisted_13, [
        _cache[10] || (_cache[10] = _createElementVNode("h1", { class: "header__logo" }, "Exclusive", -1)),
        _createElementVNode("ul", _hoisted_14, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navLinks, (link) => {
            return _createElementVNode("li", {
              key: link.id,
              class: "header__nav-item"
            }, [
              _createVNode(_unref(RouterLink), {
                class: "header__nav-link",
                to: link.to,
                "exact-active-class": link.exact ? 'active-link' : undefined,
                "active-class": "active-link"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(link.name), 1)
                ]),
                _: 2
              }, 1032, ["to", "exact-active-class"])
            ])
          }), 64))
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _withDirectives(_createElementVNode("input", {
              class: "header__search-input",
              type: "text",
              placeholder: "What are you looking for?",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(searchQuery) ? (searchQuery).value = $event : null)),
              onInput: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_unref(handleSearchInput) && _unref(handleSearchInput)(...args))),
              onKeyup: _cache[6] || (_cache[6] = _withKeys(
//@ts-ignore
(...args) => (_unref(handleSearch) && _unref(handleSearch)(...args)), ["enter"]))
            }, null, 544), [
              [_vModelText, _unref(searchQuery)]
            ]),
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "header__search-icon" }, [
              _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: "search-icon",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor",
                "stroke-width": "2"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  d: "M21 21l-4.35-4.35m0 0A7.5 7.5 0 1110.5 3a7.5 7.5 0 016.15 13.65z"
                })
              ])
            ], -1)),
            (_unref(searchResults).length > 0 || _unref(searchLoading) || _unref(showNoResults))
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  (_unref(searchLoading))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createVNode(_component_base_loader, { size: "24px" })
                      ]))
                    : (_unref(searchResults).length > 0)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(searchResults), (result) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: result.id,
                            class: "header__search-dropdown-item",
                            onClick: ($event: any) => (_unref(handleSelectResult)(result))
                          }, [
                            _createElementVNode("img", {
                              src: result.thumbnail,
                              alt: result.title
                            }, null, 8, _hoisted_20),
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("p", _hoisted_22, _toDisplayString(result.title), 1),
                              _createElementVNode("p", _hoisted_23, " $" + _toDisplayString(result.price), 1)
                            ])
                          ], 8, _hoisted_19))
                        }), 128))
                      : (_openBlock(), _createElementBlock("div", _hoisted_24, " No products found "))
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", {
            class: "header__search-mobile-icon",
            onClick: openSearch
          }, [...(_cache[9] || (_cache[9] = [
            _createElementVNode("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              fill: "none",
              viewBox: "0 0 24 24",
              stroke: "currentColor",
              "stroke-width": "2"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                d: "M21 21l-4.35-4.35m0 0A7.5 7.5 0 1110.5 3a7.5 7.5 0 016.15 13.65z"
              })
            ], -1)
          ]))]),
          _createVNode(CartComponent),
          _createElementVNode("div", {
            class: "header__hamburger",
            onClick: toggleMenu
          }, "☰")
        ])
      ])
    ])
  ]))
}
}

})